<article class="dashboard-card" (click)="onTileClick(tileInfo)" [style.background]="backgroundColor">

  <div class="card-icon-wrapper">
    <img [src]="'assets/icons/'+tileInfo.icon+'.svg'" alt="" />
  </div>
  <div class="fav-icon-wrapper" (mouseenter)="isHovered = true" (mouseleave)="isHovered = false"
    (click)="onFavIconClick($event,tileInfo.cardKey)" [class.fav-wrapper]="tileInfo.favorite">
    @if(!tileInfo.favorite) {
    <div>
      <img [src]="isHovered ? 'assets/icons/star-gradient.svg' : 'assets/icons/star.svg'" class="star-icon" alt="" />
    </div>
    }
    @if(tileInfo.favorite) {
    <div>
      <img [src]="'assets/icons/star-gold.svg'" class="star-icon" alt="" />
    </div>
    }
  </div>
  <div class="card-content">
    <p class="card-name">{{ tileInfo.name }}</p>
    <p class="card-description" [innerHTML]="tileInfo.description"></p>

  </div>
</article>